import { get, post } from "../services/HttpService";


export class SmartCollectGstInvoice {
    constructor(invoiceObject = {}) {
        this.set(invoiceObject);
    };

    static validations = {
       
    };

    /**
     * @memberof SmartCollectGstInvoice
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/gst_invoices/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof SmartCollectGstInvoice
     * @type API
     * @returns Promise
     */
    download = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/gst_invoices/${this.id}/download/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

     /**
     * @memberof SmartCollectGstInvoice
     * @type API
     * @returns Promise
     */
    download_report = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/gst_invoices/${this.id}/report/download/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof SmartCollectGstInvoice
     * @type Getter Method
     * @takes void
     * @returns GstInvoice Params
     */
    get = () => {
        return {
            id: this.id,
            month: this.month,
            invoice_number: this.invoice_number,
            gross_amount: this.gross_amount,
            gst_amount: this.gst_amount,
            net_amount: this.net_amount,
        }
    };

    /**
     * @memberof SmartCollectGstInvoice
     * @type Setter Method
     * @takes GstInvoice Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };
}